import { Controller } from '@hotwired/stimulus';

// The brightest a code can be shown: one thing, as big as the screen, on pure
// white, with the screen asked to stay on — the QR at a door, in a hand, in a
// queue. Inside Telegram it also asks for fullscreen (Bot API 8.0+), which
// drops the header and gives the code the whole glass.
//
// What it cannot do is raise the phone's brightness: neither the web nor
// Telegram's Mini App API has such a thing (core.telegram.org/bots/webapps
// lists fullscreen and no brightness, no wake lock). White fill is as close as
// a page gets, and the wake lock — where the webview grants it — only stops
// the screen from dimming while somebody looks for the person with the
// scanner.
//
//   <div data-controller="bright">
//     <button type="button" data-action="bright#open"> small code </button>
//     <dialog data-bright-target="dialog" data-action="click->bright#close close->bright#release"> big code </dialog>
//   </div>
//
// Registered as "bright" by registerJane (register.js).
export default class extends Controller {
  static targets = ['dialog'];

  open() {
    this.dialogTarget.showModal();
    this.hold();
  }

  close() {
    this.dialogTarget.close();
  }

  async hold() {
    try {
      this.lock = await navigator.wakeLock?.request('screen');
    } catch {
      // refused (battery saver, a webview without it): the code still shows
    }
    this.fullscreen('requestFullscreen');
  }

  // The dialog's own `close` event — Esc or a tap anywhere on it.
  release() {
    this.lock?.release().catch(() => {});
    this.lock = null;
    this.fullscreen('exitFullscreen');
  }

  disconnect() {
    this.release();
  }

  fullscreen(method) {
    const tg = window.Telegram?.WebApp;
    if (!tg?.initData || (method === 'requestFullscreen') === tg.isFullscreen) return;

    try {
      tg[method]?.();
    } catch {
      // an older client: the white dialog is still the whole viewport
    }
  }
}
